import {I18nContextValues} from 'react-i18next'
import {Client, ClientType} from '../../../graphql/types'
import messages from '../../../assets/messages'
import {RouterProps} from 'react-router-dom'

export type InputClientType = Client['clientType']

type GetClientProfileTitleInputType = {
  t: I18nContextValues['t']
  clientType: InputClientType
}

type GetClientProfileTitleReturnType = ReturnType<I18nContextValues['t']>

const allowedCorporateClientTypes: ClientType[] = [
  ClientType.Corporate,
  ClientType.AffiliateCorporate,
  ClientType.IbCorporate,
]

export function isCorporateProfile(clientType: InputClientType): boolean {
  if (!clientType) return false

  return allowedCorporateClientTypes.includes(clientType)
}

export function getProfileSettingsTitleByClientType({
  t,
  clientType,
}: GetClientProfileTitleInputType): GetClientProfileTitleReturnType {
  if (isCorporateProfile(clientType)) {
    return t(
      messages.corporateProfileSettingsCardTitle.i18nKey,
      messages.corporateProfileSettingsCardTitle.defaults,
    )
  }

  return t(messages.profileSettingsCardTitle.i18nKey, messages.profileSettingsCardTitle.defaults)
}

export function getProfileSettingsSubTitleByClientType({
  t,
  clientType,
}: GetClientProfileTitleInputType): GetClientProfileTitleReturnType {
  if (isCorporateProfile(clientType)) {
    return t(
      messages.corporateProfileSettingsCard.i18nKey,
      messages.corporateProfileSettingsCard.defaults,
    )
  }

  return t(messages.profileSettingsCard.i18nKey, messages.profileSettingsCard.defaults)
}

export function getProfileSettingsTooltipByClientType({
  t,
  clientType,
}: GetClientProfileTitleInputType): {
  filled: GetClientProfileTitleReturnType
  pending: GetClientProfileTitleReturnType
} {
  if (isCorporateProfile(clientType)) {
    return {
      filled: t(
        messages.corporateSettingsTooltip1.i18nKey,
        messages.corporateSettingsTooltip1.defaults,
      ),
      pending: t(
        messages.corporateSettingsTooltip1Pending.i18nKey,
        messages.corporateSettingsTooltip1Pending.defaults,
      ),
    }
  }

  return {
    filled: t(messages.profileSettingsTooltip1.i18nKey, messages.profileSettingsTooltip1.defaults),
    pending: t(
      messages.profileSettingsTooltip1Pending.i18nKey,
      messages.profileSettingsTooltip1Pending.defaults,
    ),
  }
}

export function handleProfileButtonClick(
  clientType: InputClientType,
  history: RouterProps['history'],
  path: string,
): void {
  if (isCorporateProfile(clientType)) {
    history.push(`${path}/corporate-profile/details`)
    return
  }

  history.push(`${path}/personal-profile/details`)
}
